import { render } from "./TransmissionOverlaySettings.vue?vue&type=template&id=50b64ea4&scoped=true"
import script from "./TransmissionOverlaySettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TransmissionOverlaySettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./TransmissionOverlaySettings.vue?vue&type=style&index=0&id=50b64ea4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b64ea4"]])

export default __exports__